module.exports = __webpack_public_path__ + "static/media/main1.f96a5fbf.png";